var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_562)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00122 1.18799C3.33789 1.18799 0.0012207 4.34299 0.0012207 7.01215C0.0012207 9.01215 1.213 10.7763 3.05867 11.8247L2.28244 14.8797C2.21322 15.1505 2.50022 15.3655 2.72033 15.2097L6.12467 12.7888C6.41167 12.8188 6.70411 12.8363 7.00122 12.8363C10.8668 12.8363 14.0012 10.2288 14.0012 7.01215C14.0012 4.34299 10.8668 1.18799 7.00122 1.18799Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white",
    transform: "translate(0.0012207 0.401367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.4d3734c598eedeee1de225a374858b32.svg";
export { ForwardRef as ReactComponent };